import React from 'react';
import { Input } from 'reactstrap';
import { Column } from '@tanstack/react-table';

export  function SimpleTableFilter({ column }: { column: Column<any, unknown> }) {
  const columnFilterValue = column.getFilterValue();
  
  // Generate unique options for select filter - must be called before any early returns
  const selectOptions = React.useMemo(() => {
    if (!column.columnDef.meta || !('filterVariant' in column.columnDef.meta)) {
      return [];
    }
    
    const { filterVariant } = column.columnDef.meta;
    if (filterVariant !== 'select') return [];
    
    const uniqueValues = new Set<string>();
    const rows = column.getFacetedRowModel().rows;
    
    rows.forEach((row) => {
      const value = row.getValue(column.id);
      if (value != null && value !== '') {
        uniqueValues.add(String(value));
      }
    });
    
    return Array.from(uniqueValues).sort();
  }, [column]);

  if (!column.columnDef.meta) {
    return null;
  }
  if (!('filterVariant' in column.columnDef.meta)) {
    return null;
  }
  const { filterVariant } = column.columnDef.meta;

  return filterVariant === 'range' ? (
    <div>
      <div className="d-flex">
        <Input
          type="number"
          value={String((columnFilterValue as [number, number])?.[0] ?? '')}
          onChange={(e) => {
            const value = e.target.value ? Number(e.target.value) : '';
            column.setFilterValue((old: [number, number]) => [value, old?.[1]]);
          }}
          placeholder="Min"
          className="mr-1"
          bsSize="sm"
          onClick={(e) => e.stopPropagation()}
        />
        <Input
          type="number"
          value={String((columnFilterValue as [number, number])?.[1] ?? '')}
          onChange={(e) => {
            const value = e.target.value ? Number(e.target.value) : '';
            column.setFilterValue((old: [number, number]) => [old?.[0], value]);
          }}
          placeholder="Max"
          className="ml-1"
          bsSize="sm"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  ) : filterVariant === 'select' ? (
    <Input
      type="select"
      onChange={(e) => column.setFilterValue(e.target.value || undefined)}
      value={(columnFilterValue as string) ?? ''}
      bsSize="sm"
      onClick={(e) => e.stopPropagation()}
    >
      <option value="">Wszystkie</option>
      {selectOptions.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </Input>
  ) : (
    <Input
      onChange={(e) => column.setFilterValue(e.target.value || undefined)}
      placeholder="Szukaj..."
      type="text"
      value={(columnFilterValue ?? '') as string}
      bsSize="sm"
      onClick={(e) => e.stopPropagation()}
    />
  );
}

export default SimpleTableFilter;
